/**
 * NOTE: This file can be deleted once we have officially stopped building our legacay webpack bundle.
 */

/**
 * Create a mock for the default export provided from `next/link`.
 * This is because the actual module has dependencies that are specific to NextJS build processes and are incompatible
 * with our legacy application build. This approach allows us to continue using `next/link` within the sunsetting legacy build
 * and replaces all use of `next/link` with a plain anchor tag, maintaining functionality.
 */
export default 'a';
